const initSwipers = () => {

  const swiperEls = document.body.querySelectorAll('.swiper');
  swiperEls.forEach(element => {
    new Swiper(element, {
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper__pagination',
      },
      navigation: {
        prevEl: '.swiper__prev',
        nextEl: '.swiper__next',
      },
      breakpoints: {
        760: { // tablet
          slidesPerView: element.dataset.slidesPerViewTablet || 1,
          spaceBetween: element.dataset.slidesPerViewTablet ? 32 : 0
        }
      }
    });
  });

}

export default initSwipers;
